// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"ebd63eb3","498":"b57fc4bd","703":"395bc45f","787":"c126fb00"}[chunkId] + ".chunk.js";
};